import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseHeroClient";
import "./Hero.css";

const Hero = () => {
  const [videoUrl, setVideoUrl] = useState(null);

  useEffect(() => {
    const fetchVideo = async () => {
      const { data, error } = supabase
        .storage
        .from("Gallery-BB")
        .getPublicUrl("Videos/BB-global-village-2026.mp4");

      if (error) {
        console.error("Error fetching video:", error.message);
        return;
      }
      setVideoUrl(data.publicUrl);
    };

    fetchVideo();
  }, []);

  return (
    <div className="hero-wrapper">
      {videoUrl && (
        <video
          className="hero-video"
          src={videoUrl}
          autoPlay
          loop
          muted
          playsInline
        />
      )}
      <div className="hero-overlay" />
    </div>
  );
};

export default Hero;